import React from "react";
import "@progress/kendo-theme-default/dist/all.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GovoLoading } from "../../../assets/logos";
import { useTranslation } from "react-i18next";
import { Check, Cancel } from "../../../assets/logos/icons";
import "./dialog-loading-collaborator.css";
/* === Custom component title for dialog loading === */
const CustomLoadingTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: "left",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600",
    // fontFamily: 'Ubuntu, sans-serif',
  };
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogSignRequestPure.titleDialogSignRequest")}</span>
    </div>
  );
};

/* === Custom component title for dialog complete === */
const CustomCompleteTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: "left",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600",
    // fontFamily: 'Ubuntu, sans-serif',
  };
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogSignRequestPure.titleDialogSignRequest")}</span>
    </div>
  );
};

/* === Custom component title for dialog error === */
const CustomErrorTitleBar = (props) => {
  const { t } = useTranslation();
  const customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "20px",
    textAlign: "left",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: "600",
    // fontFamily: 'Ubuntu, sans-serif',
  };
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogSignRequestPure.titleDialogSignRequest")}</span>
    </div>
  );
};

const DialogCollaboratorPure = (props) => {
  const { t } = useTranslation();

  const containerImageLoadingStyles = {
    marginTop: "10px",
    width: "75px",
    height: "75px",
  };
  const containerImageCustomStyles = {
    marginTop: "10px",
    width: "55px",
    height: "55px",
  };
  return (
    <div>
      {/* === DIALOG LOADIGN === */}
      {props.showLoadingRequesting && (
        <Dialog
          className={"huella-loading"}
          title={<CustomLoadingTitleBar />}
          onClose={() => {
            props.toggleLoadingRequesting(false);
          }}
          width={256}
          height={280}
        >
          <p style={{ textAlign: "center" }}>
            <img
              alt=""
              src={GovoLoading}
              style={containerImageLoadingStyles}
            ></img>
          </p>
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            {t("dialogSignRequestPure.titleExecutingRequest")}
          </p>
        </Dialog>
      )}

      {/* === DIALOG SUCCESSFUL === */}
      {props.showCompletedRequesting && (
        <Dialog
          title={<CustomCompleteTitleBar />}
          onClose={() => {
            props.toggleCompletedRequesting(false);
          }}
          width={256}
          height={280}
        >
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            <img alt="" src={Check} style={containerImageCustomStyles} />
          </p>
          <p style={{ textAlign: "center" }}>
            {t("dialogSignRequestPure.requestSucces")}
          </p>
          {/* <p style={{ textAlign: "center" }}>{props.message ? props.message : t('dialogSignRequestPure.requestSucces')}</p> */}
        </Dialog>
      )}

      {/* === DIALOG ERROR === */}
      {props.showErrorRequesting && (
        <Dialog
          title={<CustomErrorTitleBar />}
          onClose={() => {
            props.toggleErrorRequesting(false);
          }}
          width={256}
          height={280}
        >
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            <img alt="" src={Cancel} style={containerImageCustomStyles} />
          </p>
          {/* <p style={{ textAlign: "center" }}>{t('dialogSignRequestPure.errorInRequest')}</p> */}
          {props.message ? (
            <p style={{ textAlign: "center" }}>{props.message}</p>
          ) : (
            <p style={{ textAlign: "center" }}>
              {t("dialogSignRequestPure.AnErroOcursiInTheRequesting")}
            </p>
          )}
        </Dialog>
      )}
      {props.showErrorDomain && (
        <Dialog
          title={<CustomErrorTitleBar />}
          onClose={() => {
            props.toggleErrorDomain(false);
          }}
          width={256}
          height={280}
        >
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            <img alt="" src={Cancel} style={containerImageCustomStyles} />
          </p>
          {props.message ? (
            <p style={{ textAlign: "center" }}>
              {props.message}
              <span className="configuration-style">
                {t("configuration.administrate.action.configuration")}
              </span>
              {props.restOfTheMessage}
            </p>
          ) : (
            <p style={{ textAlign: "center" }}>
              {t("configuration.administrate.action.errorDomain")}
              <span className="configuration-style">
                {t("configuration.administrate.action.configuration")}
              </span>
              {t("configuration.administrate.action.errorDomainAll")}
            </p>
          )}
        </Dialog>
      )}
    </div>
  );
};
export { DialogCollaboratorPure as default };
